import { render, staticRenderFns } from "./MvdprojectDetails.vue?vue&type=template&id=2c404234&"
import script from "./MvdprojectDetails.vue?vue&type=script&lang=js&"
export * from "./MvdprojectDetails.vue?vue&type=script&lang=js&"
import style0 from "./MvdprojectDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports